export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

export const EDIT_PRODUCT_REQUEST = "EDIT_PRODUCT_REQUEST";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILURE = "EDIT_PRODUCT_FAILURE";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const PATCH_PRODUCT_REQUEST = "PATCH_PRODUCT_REQUEST";
export const PATCH_PRODUCT_SUCCESS = "PATCH_PRODUCT_SUCCESS";
export const PATCH_PRODUCT_FAILURE = "PATCH_PRODUCT_FAILURE";


export const GET_PRODUCTS_REQUEST1 = "GET_PRODUCTS_REQUEST1";
export const GET_PRODUCTS_SUCCESS1 = "GET_PRODUCTS_SUCCESS1";
export const GET_PRODUCTS_FAILURE1 = "GET_PRODUCTS_FAILURE1";

export const ADD_PRODUCT_REQUEST1 = "ADD_PRODUCT_REQUEST1";
export const ADD_PRODUCT_SUCCESS1 = "ADD_PRODUCT_SUCCESS1";
export const ADD_PRODUCT_FAILURE1 = "ADD_PRODUCT_FAILURE1";


export const DELETE_PRODUCT_REQUEST1 = "DELETE_PRODUCT_REQUEST1";
export const DELETE_PRODUCT_SUCCESS1 = "DELETE_PRODUCT_SUCCESS1";
export const DELETE_PRODUCT_FAILURE1= "DELETE_PRODUCT_FAILURE1";







export const EDIT_PRODUCT_REQUEST1 = "EDIT_PRODUCT_REQUEST1";
export const EDIT_PRODUCT_SUCCESS1 = "EDIT_PRODUCT_SUCCESS1";
export const EDIT_PRODUCT_FAILURE1 = "EDIT_PRODUCT_FAILURE";


export const PATCH_PRODUCT_REQUEST1 = "PATCH_PRODUCT_REQUEST1";
export const PATCH_PRODUCT_SUCCESS1 = "PATCH_PRODUCT_SUCCESS1";
export const PATCH_PRODUCT_FAILURE1 = "PATCH_PRODUCT_FAILURE1";
